import React, { Component } from "react";
import { Link } from "react-router-dom";
import FooterSVGShape from "./FooterSVGShape";
import linkedInIcon from "../../assets/images/callgage-linkedin.svg";
import facebookIcon from "../../assets/images/callgage-facebook.svg";
import instaIcon from "../../assets/images/callgage-insta.svg";
import "../../styles/footer/Footer.css";
import $ from "jquery";

export default class Footer extends Component {
  componentDidMount() {
    // Store some values
    this.el = $(".Footer");
    this.footerSVGShape = $(".Footer .FooterSVGShape");
    this.contentContainer = $(".Footer .content-container");

    // Manually set the height of the footer
    $(window).on("resize", this.onResize.bind(this));
    this.setHeight();
  }

  // On Window Resize
  onResize() {
    this.setHeight();
  }

  // Manually set the height of .Footer
  setHeight() {
    if ($(".FooterSVGShape").css("display") !== "none") {
      this.el.css("height", this.footerSVGShape.height());
      this.contentContainer.css({
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: "85px"
      });
    } else {
      this.el.css("height", "auto");
      this.contentContainer.css({
        position: "relative",
        bottom: 0,
        left: 0,
        transform: "none"
      });
    }
  }

  // Set the height
  render() {
    var renderAttributions;
    if (window.location.pathname === "/seo") {
      renderAttributions = (
        <div className="attribution-container">
          <a
            className="g-sub-text"
            href="#"
          >
            Finance Vectors by Vecteezy
          </a>
          <a
            className="g-sub-text"
            href="#"
          >
            Infographic vector created by fullvector - www.freepik.com
          </a>
        </div>
      );
    }
    return (
      <div className="Footer">
        <FooterSVGShape page={this.props.page} />
        <div className="content-container gutters">
          {/* The Upper Columns */}
          <div className="top-section">
            {/* Social Media Icons */}
            <div className="contact-container">
              <div className="icon-container">
                <a href="#">
                  <img
                    className="icon facebook"
                    src={facebookIcon}
                    alt="Facebook icon"
                  />
                </a>
                <a href="#">
                  <img
                    className="icon linked-in"
                    src={linkedInIcon}
                    alt="LinkedIn icon"
                  />
                </a>
                <a href="#">
                  <img
                    className="icon insta"
                    src={instaIcon}
                    alt="Instagram icon"
                  />
                </a>
              </div>
            </div>

            {/* The Page Link Column */}
            <div className="page-container">
              <Link to="/" className="g-link white">
                Home
              </Link>
              <Link to="/about" className="g-link white">
                About Us
              </Link>
              <Link to="/contact" className="g-link white">
                Contact Us
              </Link>
            </div>
          </div>

          {/* The Copyrite Claim */}
          <div className="copyright g-sub-text white">
            Copyright © 2019 Callgage. All Rights Reserved
          </div>

          {/* Image Attributions */}
          {renderAttributions}
        </div>
      </div>
    );
  }
}
